import styled from "styled-components";

const ImageLoading = styled.img`
  width: 100px;
  height: 100px;
  margin: ${props => props.margin};
`;

export default ImageLoading;